import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { setup } from 'axios-cache-adapter';
import Decode from '@/utils/Decode';
import SlideUpDown from 'vue-slide-up-down';

// import style
import 'swiper/css/swiper.css'

import VueSmoothScroll from 'vue2-smooth-scroll';
Vue.component('slide-up-down', SlideUpDown);

Vue.use(VueSmoothScroll);
Vue.config.productionTip = false;
Vue.prototype.$decode =  Decode;
Vue.prototype.$base_url = '';


///wp-json/cocart/v1/add-item
const ajax = setup({
    baseURL: window.globals.api_url,
    cache: {
        maxAge: 20 * 60 * 1000, // 20min
        exclude: {
            query: false
        }
    },
});

const cart = setup({
    baseURL: window.globals.home_url + '/wp-json/cocart/v2/',
    cache: {
        maxAge: 0, // no cache
        exclude: {
            query: false
        }
    },
    withCredentials: true,
    withAuthorization: true,
});


Vue.prototype.$ajax = ajax;
Vue.prototype.$cart = cart;

// Vue.prototype.isDesktop = device('desktop');
// Vue.prototype.isTablet = device('tablet');
// Vue.prototype.isMobile =  device('mobile');


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
